import React from 'react';

import Messages from './Messages';
import NavBarInterface from '../../UserInterface/NavBarInterface';
import SideBar from '../../UserInterface/SideBar';






function MessagesView() {
    return (
        <div>
            <NavBarInterface />

            <div className="container-fluid">
                <div className="row">
                    <div>
                        <SideBar />
                    </div>
                    {/* <div  className="col-10" style={{  backgroundColor:'#F7F9FA'}}> */}
                        <Messages/>
                    {/* </div> */}
                </div>
            </div>
        </div>
    );
}



export default MessagesView;